import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'icon-map-pin-blue',
  templateUrl: './map-pin-blue.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapPinBlueComponent {}
